export enum ControlsType {
   EARTH = "EARTH",
   ORBIT = "ORBIT",
   FPS = "FPS",
   CONSTRAINED = "CONSTRAINED"
}